<template>
  <div data-private class="">
    <PageHeader
      title="Task Administration"
      subtitle="Manage tasks, opportunities, and assignments across your organization"
      :breadcrumbs="[{ label: 'Admin Console' }]"
    >
      <template #bottom>
        <Page_Tabs
          class="px-6 pt-4"
          :tabs="tabLabels"
          :initial-tab="currentModeLabel"
          no-border
          @select="handleTabSelect"
        />
      </template>
    </PageHeader>

    <div class="p-4">
      <!-- Mode Components -->
      <div class="bg-white rounded-lg shadow-sm border border-gray-200">
        <component :is="currentComponent" />
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import TaskAdminUnified from "@/components/Portal/Admin/Components/TaskAdminUnified.vue";
import TaskAdminDuplicatesMode from "@/components/Portal/Admin/Components/TaskAdminDuplicatesMode.vue";
import TaskAdminBulkAssignMode from "@/components/Portal/Admin/Components/TaskAdminBulkAssignMode.vue";
import PageHeader from '@/components/widgetcomponents/library/PageHeader.vue';
import Page_Tabs from '@/components/widgetcomponents/Page_Tabs.vue';

// Local storage key for saving the current mode
const CURRENT_MODE_STORAGE_KEY = 'task-admin-current-mode';

export default {
  name: 'TaskAdmin',

  components: {
    FontAwesomeIcon,
    TaskAdminUnified,
    TaskAdminDuplicatesMode,
    TaskAdminBulkAssignMode,
    PageHeader,
    Page_Tabs
  },

  data() {
    // Try to get the saved mode from localStorage, default to 'unified' if not found
    // Map old 'practice' and 'search' modes to 'unified' for backward compatibility
    let savedMode = localStorage.getItem(CURRENT_MODE_STORAGE_KEY) || 'unified';
    if (savedMode === 'practice' || savedMode === 'search') {
      savedMode = 'unified';
    }

    return {
      viewModes: [
        {
          value: 'unified',
          label: 'Search & Manage',
          icon: ['fas', 'search'],
          description: 'Search for opportunities or tasks, batch action tasks, and bulk delete duplicates'
        },
        {
          value: 'duplicates',
          label: 'Duplicates Only',
          icon: ['fas', 'copy'],
          description: 'Identify and manage duplicate opportunities and tasks'
        },
        {
          value: 'bulkAssign',
          label: 'Bulk Assign',
          icon: ['fas', 'users-cog'],
          description: 'Assign multiple tasks to users based on entity and filter criteria'
        }
      ],
      currentMode: savedMode
    };
  },

  computed: {
    currentComponent() {
      const componentMap = {
        'unified': 'TaskAdminUnified',
        'duplicates': 'TaskAdminDuplicatesMode',
        'bulkAssign': 'TaskAdminBulkAssignMode'
      };
      return componentMap[this.currentMode] || 'TaskAdminUnified';
    },
    tabLabels() {
      return this.viewModes.map(m => m.label);
    },
    currentModeLabel() {
      const mode = this.viewModes.find(m => m.value === this.currentMode);
      return mode ? mode.label : this.viewModes[0].label;
    }
  },

  methods: {
    changeMode(mode) {
      this.currentMode = mode;
      localStorage.setItem(CURRENT_MODE_STORAGE_KEY, mode);
    },
    handleTabSelect(label) {
      const mode = this.viewModes.find(m => m.label === label);
      if (mode) this.changeMode(mode.value);
    }
  }
};
</script>

<style scoped>
/* Component-specific styles if needed */
</style>
